import { render, staticRenderFns } from "./ActorEditProfile.vue?vue&type=template&id=99b518a0&scoped=true&"
import script from "./ActorEditProfile.vue?vue&type=script&lang=js&"
export * from "./ActorEditProfile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99b518a0",
  null
  
)

export default component.exports